import React, { useEffect } from "react";
import { Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { actions } from "./modules/Auth/_redux/authRedux";
import {handleLogin} from "./handle_login";
const PilotLandingPage = () => {
    const history = useHistory();
    const dispatch = useDispatch();

    const { authToken, user } = useSelector((state) => ({
        authToken: state.auth.authToken,
        user: state.auth.user,
    }));

    useEffect(() => {
        const initializePilot = () => {
            const params = new URLSearchParams(window.location.search);
            const accessToken = params.get("access_token");
            const refreshToken = params.get("refresh_token");

            if (accessToken && refreshToken) {
                dispatch(actions.login(accessToken, refreshToken, window.location.origin));
                handleLogin({access_token: accessToken, refresh_token: refreshToken, dispatch})
            } else {
                console.error("Access or refresh token missing in the redirect URL.");
                history.push("/auth/login");
            }
        };

        initializePilot();
    }, []);

    useEffect(() => {
        if (user) {
            history.push("/");
        }
    }, [user, history]);

    return (
        <div className="d-flex flex-row justify-content-center align-items-center">
            <Spin spinning={!authToken} />
        </div>
    );
};

export default PilotLandingPage;
